// extracted by mini-css-extract-plugin
export default {"Auth":"Auth_Auth__dwG9v","Logo":"Auth_Logo__IF44m","Title":"Auth_Title__lBTro","Error":"Auth_Error__A-FnA"};